import React, { memo, useState } from 'react'
import { pick } from 'lodash-es'
import styled from '@emotion/styled'
import { Button, Toast, Modal } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import { useDataOperateStore } from '../tables/data-operate/data-operate-store-provider'
import BatchAdd from './batchAdd'

const StyledButton = styled(Button)`
  font-size: 13px;
  margin: 0 -4px;
`

const DeleteButton = ({ id }) => {
  const [loading, setLoading] = useState(false)
  const refreshTree = useDataOperateStore((state) => state.refreshTree)
  const { destroyTbData, ditto } = useTbViewStore((state) =>
    pick(state, ['destroyTbData', 'ditto'])
  )
  return (
    <Modal
      trigger={
        <StyledButton type="error" opacityType="transparent">
          删除
        </StyledButton>
      }
      showCloseButton
      width="400px"
      title="提示"
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={({ close }) => (
        <>
          <Button
            type="secondary"
            opacityType="sm"
            style={{ marginRight: '10px' }}
            onClick={close}
          >
            取消
          </Button>
          <Button
            type="primary"
            loading={loading}
            onClick={() => {
              setLoading(true)
              destroyTbData(id)
                .then(() => {
                  Toast.success({
                    title: '删除成功',
                  })
                  ditto.cleanTbDataCache()
                  if (refreshTree) refreshTree()
                })
                .catch((err) => {
                  Toast.error({
                    title: '删除失败',
                    description: err.message,
                  })
                })
                .finally(() => {
                  close()
                  setLoading(false)
                })
            }}
          >
            确定
          </Button>
        </>
      )}
    >
      <div className="flex flex-col gap-4">
        <div className="text-sm">确定删除？删除后不可恢复</div>
      </div>
    </Modal>
  )
}

const Operate = ({ rowData, rowIndex }) => {
  const [loading, setLoading] = useState(false)
  const {
    ditto,
    tbDefs,
    freshTbDataByIds,
    tbData,
    setTbData,
    updateNodeOrder,
  } = useTbViewStore((state) =>
    pick(state, [
      'ditto',
      'tbDefs',
      'freshTbDataByIds',
      'tbData',
      'setTbData',
      'updateNodeOrder',
    ])
  )

  const refreshTree = useDataOperateStore((state) => state.refreshTree)

  const toggleDisable = () => {
    setLoading(true)
    ditto
      .toggleNodeEnabled({
        objectId: rowData.objectId,
        disable: !rowData.isDisableNode,
      })
      .then(() => {
        return freshTbDataByIds([rowData.objectId])
      })
      .catch((err) => {
        Toast.error({
          title: '操作失败',
          description: err.error,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onCreate = async (data) => {
    try {
      const peer = data.filter((item) => item.level === rowData.level)

      setTbData([
        ...tbData.slice(0, rowIndex + 1),
        ...peer,
        ...tbData.slice(rowIndex + 1),
      ])

      await updateNodeOrder()

      if (refreshTree) refreshTree()
    } catch (err) {
      Toast.error({
        title: '操作失败',
        description: err.message,
      })
    }
  }

  return (
    <div className="row-operate flex flex-row justify-end w-full h-full invisible bg-primary-50">
      <BatchAdd
        type={tbDefs.tbNameId}
        refreshTreeData={onCreate}
        parentId={rowData.parentId}
      >
        <StyledButton type="primary" opacityType="transparent">
          添加
        </StyledButton>
      </BatchAdd>
      <StyledButton
        type="primary"
        opacityType="transparent"
        onClick={toggleDisable}
        loading={loading}
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {loading ? '' : rowData.isDisableNode ? '启用' : '禁用'}
      </StyledButton>
      <DeleteButton id={rowData.objectId} />
    </div>
  )
}

export default memo(Operate)
